export default [
  {
    path: "/",
    redirect: {
      path: "/minhas-viagens",
    },
  },
  {
    path: "/minhas-viagens",
    name: "my-trips",
    meta: {
      authorize: [],
      breadcrumb: "Minhas Viagens",
    },
    component: () =>
      import(/* webpackChunkName: "my-trips" */ "@/views/my-trips/index.vue"),
  },
  {
    path: "/minhas-viagens/nova",
    name: "my-trips-new",
    meta: {
      authorize: [],
      breadcrumb: "Nova Viagem",
    },
    component: () =>
      import(/* webpackChunkName: "my-trips" */ "@/views/my-trips/new.vue"),
  },
  {
    path: "/minhas-viagens/:id",
    name: "my-trips-show",
    meta: {
      authorize: [],
      breadcrumb: "Detalhe da Viagem",
    },
    component: () =>
      import(/* webpackChunkName: "my-trips" */ "@/views/my-trips/show.vue"),
  },
  {
    path: "/minhas-viagens-pendentes",
    name: "my-trips-pending",
    meta: {
      authorize: [],
      breadcrumb: "Viagens pendentes de sincronização",
    },
    component: () =>
      import(
        /* webpackChunkName: "my-trips" */ "@/views/trips-pending/pending.vue"
      ),
  },
];
